
import Banner from '@/components/Banner.vue'
import Bucket from '@/components/Bucket.vue'
import NoShiptos from '@/components/NoShiptos.vue'
import PayOnline from '@/components/PayOnline.vue'
import ContactUs from '@/components/ContactUs.vue'
import Welcome from '@/components/Welcome.vue'
import moment from 'moment'
import { GetData } from '@/service'

export default {
  name: 'Home',
  components: {
    Banner,
    Bucket,
    NoShiptos,
    PayOnline,
    ContactUs,
    Welcome
  },
  data() {
    return {
      company: window.apci.getUserCompany(),
      buckets: [],
      phoneNumbers: {},
      bannerMessage: {}
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    shipTos() {
      return this.$store.state.shipTos
    },
    applications() {
      return this.$store.state.applications
    },
    showPayOnline() {
      return !['US', 'CA', 'BR', 'AR', 'CL', 'CO', 'EC', 'PE', 'AE', 'OM', 'TW', 'CN', 'KR', 'ID', 'MY', 'SG', 'IL', 'HU'].includes(
        this.user.countryCode
      )
    },
    hasMriApplication() {
      return this.$store.state.applications.some((a) => a.applicationName === 'MRIKCP')
    },
    hasInvoiceApplication() {
      return this.$store.state.applications.some((a) => a.applicationName === 'Invoice')
    },
    hasN2MembraneSizing() {
      return this.$store.state.applications.some((a) => a.applicationName === 'N2MembraneSizing')
    },
    revalidationStatus() {
      return this.$store.state.revalidationStatus
    },
    showNeedHelp() {
      return !['IL'].includes(this.user.countryCode)
    },
    showBannerMessage() {
      if (this.bannerMessage && this.bannerMessage.startDate_TextFormat && this.bannerMessage.endDate_TextFormat) {
        const startDate = moment(this.bannerMessage.startDate_TextFormat, 'DD-MM-YYYY'),
          endDateOrg = moment(this.bannerMessage.endDate_TextFormat, 'DD-MM-YYYY'),
          endDateNew = moment(endDateOrg.add(1, 'days'), ('DD-MM-YYYY')),
          currentDate = moment();
        if (startDate.isSameOrBefore(currentDate) && endDateNew.isSameOrAfter(currentDate)) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    bucketImagePath(file) {
      return require(`@/assets/bucket_icons/${file}`)
    }
  },
  async mounted() {
    const resbuckets = await GetData('/api/v1/navigation/buckets');
    if (resbuckets.status === 200) this.buckets = resbuckets.data;
    const resPhone = await GetData('/api/v1/user/phonenumbers');
    if (resPhone.status === 200) this.phoneNumbers = resPhone.data;
    const resBanner = await GetData('/api/v1/user/banner-message');
    if (resBanner.status === 200) this.bannerMessage = resBanner.data;
  }
}
